<ul>
  <li><a [routerLink]="'/users'" [routerLinkActive]="'app-menu-active'">{{ "users-page.title" | translate }}</a></li>
  <li><a [routerLink]="'/bands'" [routerLinkActive]="'app-menu-active'">{{ "bands-page.title" | translate }}</a></li>
  <li><a [routerLink]="'/events'" [routerLinkActive]="'app-menu-active'">{{ "events-page.title" | translate }}</a></li>
  <li><a [routerLink]="'/feedbacks'" [routerLinkActive]="'app-menu-active'">{{ "feedbacks-page.title" | translate }}</a></li>
  <li><a [routerLink]="'/push'" [routerLinkActive]="'app-menu-active'">{{ "push-page.title" | translate }}</a></li>
  <li><a [routerLink]="'/special-campaigns'" [routerLinkActive]="'app-menu-active'">{{ "special-campaigns-page.title" | translate }}</a></li>
  <li><a [routerLink]="'/settings'" [routerLinkActive]="'app-menu-active'">{{ "settings-page.title" | translate }}</a></li>
</ul>
